import { render, staticRenderFns } from "./DashboardInventario.vue?vue&type=template&id=2a3abb7c"
import script from "./DashboardInventario.vue?vue&type=script&lang=js"
export * from "./DashboardInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports